import { showFavoritesFoldersList, showModalCreateFolder } from '@cian/favorites-assign-widget';
import { Button } from '@cian/ui-kit';
import * as React from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { requestAuthentication } from '../../actions/authentication';
import { AddToFolderIcon } from '../../components/Icons/AddToFolderIcon';
import { selectUser, selectFolders } from '../../selectors';

interface IAddToFolderButtonContainerProps {
  entityId: number;
}

export function AddToFolderButtonContainer({ entityId }: IAddToFolderButtonContainerProps) {
  const dispatch = useDispatch();
  const user = useSelector(selectUser);
  const folders = useSelector(selectFolders);

  const handleClick = React.useCallback(() => {
    if (user.isAuthenticated) {
      dispatch((folders.length ? showFavoritesFoldersList : showModalCreateFolder)({ offerIds: [entityId] }));
    } else {
      dispatch(requestAuthentication());
    }
  }, [dispatch, entityId, folders, user.isAuthenticated]);

  return (
    <Button
      size="XS"
      theme="fill_secondary"
      onClick={handleClick}
      beforeIcon={<AddToFolderIcon color="icon-main-default" />}
      title="Сохранить в подборку"
    />
  );
}
